import { Checkbox } from "components/Atoms/inputs/Checkbox";
import { Loading } from "components/panels";
import { VerticalKeyboardNavigationGroup } from "keyboardNavigation/KeyboardNavigationPresets";
import React from "react";
import classNames from "classnames";

interface Props<T> {
  options: T[]
  getId: (item: T) => string | number
  getLabel: (item: T) => React.ReactNode
  getDisabled?: (item: T) => boolean
  value: T[]
  onChange: (selected: T[]) => void
  multipleColumns: boolean
  inPageEditing: "new" | "edit" | "none"
  keyboardNavigationGroup: string
  isLoading?: boolean
  emptyMessage?: React.ReactNode
}

export const CheckboxList = <T,>(props: Props<T>) => {
  const containerClass = classNames({
    "main-section-template-fields-padding": props.inPageEditing !== "none",
    "multiple-columns": props.multipleColumns
  });

  const containerStyle: React.CSSProperties | undefined = props.inPageEditing === "new"
    ? { paddingLeft: 0, paddingRight: 0 }
    : undefined;

  if (props.isLoading) {
    return <div className={containerClass} style={containerStyle}><Loading /></div>;
  }

  if (props.options.length === 0) {
    return <div
      className={classNames(containerClass, "main-section-template-fields-empty")}
      style={containerStyle}
    >
      {props.emptyMessage ?? RESX.Advancing.NoValue}
    </div>;
  }

  const selected = new Set(props.value.map(props.getId));

  const toggle = (item: T, checked: boolean) => {
    const id = props.getId(item);
    props.onChange(
      checked
        ? [...props.value, item]
        : props.value.filter(v => props.getId(v) !== id)
    );
  };

  return <div className={containerClass} style={containerStyle}>
    {props.options.map(opt => {
      const id = props.getId(opt);
      return <div className="margin-bottom-mini" key={id}>
        <Checkbox
          keyboardNavigationOptions={VerticalKeyboardNavigationGroup(props.keyboardNavigationGroup)}
          checked={selected.has(id)}
          disabled={props.getDisabled?.(opt)}
          label={props.getLabel(opt)}
          onChange={(_, checked) => toggle(opt, checked)}
        />
      </div>;
    })}
  </div>;
};
